import { LabMDM } from "./lab";
import { OperetionHistoryDTO } from "./operationHistory";

export class StepCategory{
    _id: string;
    stepCategoryName:string;
    lab:LabMDM;
    active:boolean;
    version : number;
    creationDate: Date;
    lastModifiedDate: Date;
    history : OperetionHistoryDTO[];
}